import AvatarsAuras_0001_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0001_0001.png';
import AvatarsAuras_0002_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0002_0001.png';
import AvatarsAuras_0003_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0003_0001.png';
import AvatarsAuras_0004_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0004_0001.png';
import AvatarsAuras_0005_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0005_0001.png';
import AvatarsAuras_0006_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0006_0001.png';
import AvatarsAuras_0007_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0007_0001.png';
import AvatarsAuras_0008_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0008_0001.png';
import AvatarsAuras_0009_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0009_0001.png';
import AvatarsAuras_0010_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0010_0001.png';
import AvatarsAuras_0011_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0011_0001.png';
import AvatarsAuras_0012_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0012_0001.png';
import AvatarsAuras_0013_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0013_0001.png';
import AvatarsAuras_0014_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0014_0001.png';
import AvatarsAuras_0015_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0015_0001.png';
import AvatarsAuras_0016_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0016_0001.png';
import AvatarsAuras_0017_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0017_0001.png';
import AvatarsAuras_0018_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0018_0001.png';
import AvatarsAuras_0019_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0019_0001.png';
import AvatarsAuras_0020_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0020_0001.png';
import AvatarsAuras_0021_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0021_0001.png';
import AvatarsAuras_0022_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0022_0001.png';
import AvatarsAuras_0023_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0023_0001.png';
import AvatarsAuras_0024_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0024_0001.png';
import AvatarsAuras_0025_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0025_0001.png';
import AvatarsAuras_0026_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0026_0001.png';
import AvatarsAuras_0027_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0027_0001.png';
import AvatarsAuras_0028_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0028_0001.png';
import AvatarsAuras_0029_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0029_0001.png';
import AvatarsAuras_0030_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0030_0001.png';
import AvatarsAuras_0031_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0031_0001.png';
import AvatarsAuras_0032_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0032_0001.png';
import AvatarsAuras_0033_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0033_0001.png';
import AvatarsAuras_0034_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0034_0001.png';
import AvatarsAuras_0035_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0035_0001.png';
import AvatarsAuras_0036_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0036_0001.png';
import AvatarsAuras_0037_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0037_0001.png';
import AvatarsAuras_0038_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0038_0001.png';
import AvatarsAuras_0039_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0039_0001.png';
import AvatarsAuras_0040_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0040_0001.png';
import AvatarsAuras_0041_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0041_0001.png';
import AvatarsAuras_0042_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0042_0001.png';
import AvatarsAuras_0043_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0043_0001.png';
import AvatarsAuras_0044_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0044_0001.png';
import AvatarsAuras_0045_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0045_0001.png';
import AvatarsAuras_0046_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0046_0001.png';
import AvatarsAuras_0047_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0047_0001.png';
import AvatarsAuras_0048_0001 from '../../assets/graphics/png/collections/avatar/auras/avatars-auras-0048_0001.png';

import {
  AvatarCategory,
  AvatarConstant,
  AvatarItem,
  AvatarSet,
  AvatarType,
} from './utils';

export enum AvatarAurasItemNo {
  a1 = 'avatars-auras-00000001',
  a2 = 'avatars-auras-00000002',
  a3 = 'avatars-auras-00000003',
  a4 = 'avatars-auras-00000004',
  a5 = 'avatars-auras-00000005',
  a6 = 'avatars-auras-00000006',
  a7 = 'avatars-auras-00000007',
  a8 = 'avatars-auras-00000008',
  a9 = 'avatars-auras-00000009',
  a10 = 'avatars-auras-00000010',
  a11 = 'avatars-auras-00000011',
  a12 = 'avatars-auras-00000012',
  a13 = 'avatars-auras-00000013',
  a14 = 'avatars-auras-00000014',
  a15 = 'avatars-auras-00000015',
  a16 = 'avatars-auras-00000016',
  a17 = 'avatars-auras-00000017',
  a18 = 'avatars-auras-00000018',
  a19 = 'avatars-auras-00000019',
  a20 = 'avatars-auras-00000020',
  a21 = 'avatars-auras-00000021',
  a22 = 'avatars-auras-00000022',
  a23 = 'avatars-auras-00000023',
  a24 = 'avatars-auras-00000024',
  a25 = 'avatars-auras-00000025',
  a26 = 'avatars-auras-00000026',
  a27 = 'avatars-auras-00000027',
  a28 = 'avatars-auras-00000028',
  a29 = 'avatars-auras-00000029',
  a30 = 'avatars-auras-00000030',
  a31 = 'avatars-auras-00000031',
  a32 = 'avatars-auras-00000032',
  a33 = 'avatars-auras-00000033',
  a34 = 'avatars-auras-00000034',
  a35 = 'avatars-auras-00000035',
  a36 = 'avatars-auras-00000036',
  a37 = 'avatars-auras-00000037',
  a38 = 'avatars-auras-00000038',
  a39 = 'avatars-auras-00000039',
  a40 = 'avatars-auras-00000040',
  a41 = 'avatars-auras-00000041',
  a42 = 'avatars-auras-00000042',
  a43 = 'avatars-auras-00000043',
  a44 = 'avatars-auras-00000044',
  a45 = 'avatars-auras-00000045',
  a46 = 'avatars-auras-00000046',
  a47 = 'avatars-auras-00000047',
  a48 = 'avatars-auras-00000048',
}

export const AVATAR_AURAS = Object.freeze<AvatarItem<AvatarCategory.Auras>[]>([
  {
    itemId: AvatarAurasItemNo.a1,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 1,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0001_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a2,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 2,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0002_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a3,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 3,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0003_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a4,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 4,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0004_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a5,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 5,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0005_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a6,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 6,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0006_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a7,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 7,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0007_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a8,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 8,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0008_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a9,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 9,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0009_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a10,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 10,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0010_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a11,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 11,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0011_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a12,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 12,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0012_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a13,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 13,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0013_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a14,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 14,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0014_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a15,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 15,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0015_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a16,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 16,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0016_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a17,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 17,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0017_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a18,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 18,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0018_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a19,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 19,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0019_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a20,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 20,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0020_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a21,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 21,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0021_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a22,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 22,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0022_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a23,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 23,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0023_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a24,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 24,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0024_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a25,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 25,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0025_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a26,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 26,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0026_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a27,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 27,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0027_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a28,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 28,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0028_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a29,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 29,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0029_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a30,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 30,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0030_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a31,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 31,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0031_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a32,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 32,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0032_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a33,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 33,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0033_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a34,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 34,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0034_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a35,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 35,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0035_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a36,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 36,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0036_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a37,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 37,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0037_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a38,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 38,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0038_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a39,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 39,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0039_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a40,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 40,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0040_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a41,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 41,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0041_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a42,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 42,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0042_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a43,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 43,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0043_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a44,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 44,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0044_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a45,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 45,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0045_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a46,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 46,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0046_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a47,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 47,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0047_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarAurasItemNo.a48,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Auras,
    type: AvatarType.AvatarAuras,
    set: AvatarSet.Limited,
    index: 48,
    isVisible: true,
    visual: {
      filePrefix: AvatarsAuras_0048_0001,
      frameCount: 1,
      hasThumbnail: false,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
]);
